import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Login from "./pages/login/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./layouts/DashboardLayout";
import OrganizationList from "./pages/organization/OrganizationList";
import OrganizationForm from "./pages/organization/OrganizationForm";
import OrganizationLevel from "./pages/organization/OrganizationLevel";
import OrganizationLevelDetail from "./pages/organization/OrganizationLevelDetail";
import CenterList from "./pages/center/CenterList";
import CenterForm from "./pages/center/CenterForm";
import SessionForm from "./pages/session/SessionForm";
import SessionList from "./pages/session/SessionList";
import ClassList from "./pages/class/ClassList";
import ClassForm from "./pages/class/ClassForm";
import AssignClassForm from "./pages/class/AssignClassForm";
import StudentList from "./pages/student/StudentList";
import StudentForm from "./pages/student/StudentForm";
import StudentProfile from "./pages/student/student_profile/StudentProfile";
import StudentFirstRegistration from "./pages/register/StudentFirstRegistration";
import UserAuthMainSetup from "./pages/user_auth/UserAuthMainSetup";
import Permissions from "./pages/site_role_permission/Permissions";
import AssignRoles from "./pages/site_role_permission/AssignRoles";
import RolePermissions from "./pages/site_role_permission/RolePermissions";
import Users from "./pages/site_role_permission/Users";
import FeeCycle from "./pages/billing/FeeCycle";
import FeeType from "./pages/billing/FeeType";
import FeePlan from "./pages/billing/FeePlan";
import AssignFeePlan from "./pages/billing/AssignFeePlan";
import AttendanceSetup from "./pages/attendance/AttendanceSetup";
import FeePlanClassWise from "./pages/billing/FeePlanClassWise";
import MenuCategories from "./pages/site_menu/MenuCategories";
import MenuSubCategories from "./pages/site_menu/MenuSubCategories";
import MenuForms from "./pages/site_menu/MenuForms";
import ConcessionPlan from "./pages/concession/ConcessionPlan";
import AssignConcessionPlan from "./pages/concession/AssignConcessionPlan";
import ConcessionPlanClassWise from "./pages/concession/ConcessionPlanClassWise";
import MarkAttendance from "./pages/attendance/MarkAttendance";
import ClassSection from "./pages/section/ClassSection";
import AcademicCalendar from "./pages/calendar/AcademicCalender";
import FileManager from "./pages/file_manager/FileManager";
import FileManagerSetup from "./pages/file_manager/FileManagerSetup";
import FileManagerPermission from "./pages/file_manager/FileManagerPermission";
import AssessmentType from "./pages/assessment/AssessmentType";
import AssessmentPlan from "./pages/assessment/AssessmentPlan";
import AssignAssessmentPlan from "./pages/assessment/AssignAssessmentPlan";
import AssessmentPlanClassWise from "./pages/assessment/AssessmentPlanClassWise";
import AdmissionList from "./pages/admission/AdmissionList";
import AdmissionMultistepForm from "./pages/admission/AdmissionMultistepForm";
//import Dashboard from "./pages/dashboard/Dashboard";
import InspSchoolManagementDashboard from "./pages/dashboard/InspSchoolManagementDashboard";
import AccountsDashboard from "./pages/dashboard/AccountsDashboard";
import ClassSetup from "./pages/class/ClassSetup";
import SubjectForm from "./pages/subjects/Subject";
import AssignSubjectForm from "./pages/subjects/AssignSubject";
import AuthorSetup from "./pages/lms/AuthorSetup";
import BookSetup from "./pages/lms/BookSetup";
import LibrarySetup from "./pages/lms/LibrarySetup";
import BookLoan from "./pages/lms/BookLoan";
import SessionSetup from "./pages/session/SessionSetup";
import LoanedBooks from "./pages/lms/LoanedBooksList";
import { post } from "./services/api";
import { toast } from "react-toastify";
import MenuOrdering from "./pages/site_menu/MenuOrdering";
import EvaluationType from "./pages/rms/EvaluationType";
import AssignGradingTo from "./pages/rms/AssignGradingToClass";
import StudentAchievementRating from "./pages/rms/StudentAchievementRating";
import SubjectItemHead from "./pages/rms/SubjectItemHead";
import SubjectClassEvaluationCriteria from "./pages/rms/SubjectClassEvaluationCriteria";
import PerformanceEvaluation from "./pages/rms/PerformanceEvaluation";
import DriverArrivalStatusList from "./pages/driver_arrival_status/DriverArrivalStatusList";
import AssignTeacher from "./pages/teacher/AssignTeacherForm";
import MobileMarketingContentSetup from "./pages/marketing_content/MobileMarketingContentSetup";
import TermSetup from "./pages/rms/TermSetup";
import TimetableSetup from "./pages/timetable/TimetableSetup";
import AssignSessionToCenter from "./pages/session/AssignSession";
import DropdownValuesSetup from "./pages/dropdown_options/DropdownValuesSetup";
import DropdownNamesSetup from "./pages/dropdown_options/DropdownNamesSetup";
import Timetable from "./pages/timetable/Timetable";
import EarlyLeaveRequest from "./pages/early_leave_request/EarlyLeaveRequest";
import MarksEvaluation from "./pages/rms/MarksEvaluation";
import EvaluationCriteriaWeightage from "./pages/rms/EvaluationCriteriaWeitage";
import DiarySetup from "./pages/diary/DiarySetup";
import ClassWorkSetup from "./pages/diary/ClassWorkSetup";
import StudentPerformanceReport from "./pages/reports/StudentPerformanceReport";
import StudentInformationReport from "./pages/reports/StudentInformationReport";
import StudentLedgerReport from "./pages/reports/StudentLedgerReport";
import RegistrationReport from "./pages/reports/RegistrationReport";
import StudentStrengthReport from "./pages/reports/StudentStrengthReport";
import StudentResultCardReport from "./pages/reports/StudentResultCardReport";
import MonthlyBilling from "./pages/billing/MonthlyBilling";
import BillingReportPage from "./pages/billing/BillingReportPage";
import StudentTransferOut from "./pages/student_transfer/StudentTransferOut";
import StudentTransferIn from "./pages/student_transfer/StudentTransferIn";
import StudentWithdrawal from "./pages/student_withdrawal/StudentWithdrawal";
import FullScreenLoader from "./components/FullScreenLoader";
import ChangePassword from "./pages/login/ChangePassword";
import GuardianRegistration from "./pages/register/GuardianRegistration";
import RegistrationForm from "./pages/register/RegistrationForm";
import MedicalForm from "./pages/register/MedicalForm";
import RegistrationsList from "./pages/register/RegistrationsList";
import ResourceAllocation from "./pages/student/ResourceAllocation";
import StudentDocuments from "./pages/student_status/StudentDocuments";
import StudentAssessments from "./pages/student_status/StudentAssessments";
import StudentAssessmentFee from "./pages/student_status/StudentAssessmentFee";
import StudentInterview from "./pages/student_status/StudentInterview";
import StudentAcceptance from "./pages/student_status/StudentAcceptance";
import WithdrawalProcess from "./pages/student_withdrawal/WithdrawalProcess";
import BankSetup from "./pages/lms/BankSetup";
import ParentStudentDashboard from "./pages/dashboard/ParentStudentDashboard";
import InquiryToEnrollmentInsights from "./pages/dashboard/InquiryToEnrollmentInsights";
import ApplicationStatus from "./pages/register/ApplicationStatus";
import DueDateSetup from "./pages/billing/DueDateSetup";
import TimeSlots from "./pages/timetable/TimeSlots";
import BookedAssessments from "./pages/assessment/BookedAssessments";
import NotificationForm from "./pages/notification/NotificationForm";
import ActivityCreationAndFeedbackForm from "./pages/activity/ActivityCreationAndFeedbackForm";
import PupilActivityEnrollmentForm from "./pages/activity/PupilActivityEnrollmentForm";
import AlertNotificationList from "./pages/notification/AlerNotificationList";
import AlertManagerForm from "./pages/notification/AlertManagerForm";
import AssignNotification from "./pages/notification/AssignNotification";
import ActivityAttendance from "./pages/attendance/ActivityAttendance";
import FormApiAction from "./pages/site_menu/FormApiAction";
import ContractCreationForm from "./pages/contract_management/ContractCreationForm";
import SchoolVendorContractForm from "./pages/contract_management/SchoolVendorContractForm";
import DefineMeetingSlots from "./pages/parent_teacher_meeting/DefineMeetingSlots";
import ParentGoogleForm from "./pages/register/ParentQuestionerForm";
import ColumnFilterTable from "./pages/student/ColumnFilterTable";
import StudentListings from "./pages/student/StudentListings";
import ParentQuestionerForm from "./pages/register/ParentQuestionerForm";
import ParentQuestionerFormList from "./pages/register/ParentQuestionerFormList";
import ActivitySetup from "./pages/activity_creation/ActivitySetup";
import EnrolledActivities from "./pages/activity_creation/EnrolledActivities";
import ExpenseAllocation from "./pages/site_menu/ExpenseAllocation";
import BookRequest from "./pages/library/BookRequest";
import LibrarianRequest from "./pages/library/LibrarianRequest";
import ShoppingCart from "./pages/purchasing/ShoppingCart";
import SalesForm from "./pages/purchasing/SalesForm";
import ProductList from "./pages/purchasing/ProductList";
import AlertManager from "./pages/alert_manager/AlertManager";
import RoleSetup from "./pages/site_menu/RoleSetup";
import UniformPage from "./pages/purchasing/UniformPage";
import Checkout from "./pages/purchasing/Checkout";
import DeliveryPage from "./pages/purchasing/DeliveryPage";
import FacilityForm from "./pages/facility/FacilityForm";
import MarketingCampaign from "./pages/marketing/MarketingCampaign";
import NotificationAttachmentTemplate from "./pages/alert_manager/NotificationAttachmentTemplate";
import RegistrationDynamicReport from "./pages/reports/RegistrationDynamicReport";
import AssignClassToSectionHead from "./pages/class/AssignClassToSectionHead";
import ActivityCertificate from "./pages/activity_creation/ActivityCertificate";
import Timetables from "./pages/asc-timetable/Timetables";
import EmailStatusReport from "./pages/alert_manager/EmailStatusReport";
import WorkflowSetupForms from "./pages/workflow/WorkflowSetupForms";
import StudentInquiry from "./pages/NewAdmissionModule/StudentInquiry";
import PtmScheduleTeacher from "./pages/PTM/PtmScheduleTeacher";
import PtmSchedulerAdmin from "./pages/PTM/PtmSchedulerAdmin";
import PtmBookingParent from "./pages/PTM/PtmBookingParent";
import FranchiseOnboardingForm from "./pages/Franchise/FranchiseOnboardingForm";
import FranchiseList from "./pages/Franchise/FranchiseList";
import Approval from "./pages/NewAdmissionModule/Approval";
import InspStudentProfile from "./pages/NewAdmissionModule/InspStudentProfile";
import AdmissionVoucher from "./pages/NewAdmissionModule/AddmissionVoucher";
import MonthlyFeeVoucher from "./pages/NewAdmissionModule/MonthlyFeeVoucher";
import RegistrationChallan from "./pages/NewAdmissionModule/RegistrationChallan";
import TicketsForm from "./pages/helpdesk_ticketing/TicketsForm";
import AutoAssignmentSetup from "./pages/helpdesk_ticketing/AutoAssignmentSetup";
import QA_CheckListForm from "./pages/qa_checklist/qa_checklist_form";
import UserReport from "./pages/site_role_permission/UserReport";

// import ChartOfAccounts from "./modules/erp/pages/ChartOfAccounts";
// import JournalTransactions from "./modules/erp/pages/JournalTransactions";
// import Vendors from "./modules/erp/pages/Vendors";
// import Customers from "./modules/erp/pages/Customers";
// import VendorBills from "./modules/erp/pages/VendorBills";
// import CustomerInvoices from "./modules/erp/pages/CustomerInvoices";
// import VendorPayments from "./modules/erp/pages/VendorPayments";
// import CustomerReceipts from "./modules/erp/pages/CustomerReceipts";
// import CreditNotes from "./modules/erp/pages/CreditNotes";
// import DebitNotes from "./modules/erp/pages/DebitNotes";
// import BankReconciliation from "./modules/erp/pages/BankReconciliation";
// import FixedAssets from "./modules/erp/pages/FixedAssets";
// import DepreciationSchedule from "./modules/erp/pages/DepreciationSchedule";
// import AssetDisposal from "./modules/erp/pages/AssetDisposal";
// import Products from "./modules/erp/pages/Products";
// import Transfer from "./modules/erp/pages/Transfer";
// import Issuance from "./modules/erp/pages/Issuance";
// import Receipt from "./modules/erp/pages/Receipt";
// import Warehouse from "./modules/erp/pages/Warehouse";
// import BOM from "./modules/erp/pages/BOM";
// import EmployeeProfile from "./modules/erp/pages/EmployeeProfile";
// import Benefits from "./modules/erp/pages/Benefits";
// import SalaryStructure from "./modules/erp/pages/SalaryStructure";
// import KPIs from "./modules/erp/pages/KPIs";
// import ConfigJournal from "./modules/erp/pages/ConfigJournal";
// import ConfigFinancialDimensions from "./modules/erp/pages/ConfigFinancialDimensions";

import ChartOfAccounts from "./modules/erp/pages/ChartOfAccounts";
import JournalTransactions from "./modules/erp/pages/JournalTransactions";
import Vendors from "./modules/erp/pages/Vendors";
import Customers from "./modules/erp/pages/Customers";
import VendorBills from "./modules/erp/pages/VendorBills";
import CustomerInvoices from "./modules/erp/pages/CustomerInvoices";
import VendorPayments from "./modules/erp/pages/VendorPayments";
import CustomerReceipts from "./modules/erp/pages/CustomerReceipts";
import CreditNotes from "./modules/erp/pages/CreditNotes";
import DebitNotes from "./modules/erp/pages/DebitNotes";
import BankReconciliation from "./modules/erp/pages/BankReconciliation";
import FixedAssets from "./modules/erp/pages/FixedAssets";
import DepreciationSchedule from "./modules/erp/pages/DepreciationSchedule";
import AssetDisposal from "./modules/erp/pages/AssetDisposal";
import Products from "./modules/erp/pages/Products";
import Transfer from "./modules/erp/pages/Transfer";
import Issuance from "./modules/erp/pages/Issuance";
import Receipt from "./modules/erp/pages/Receipt";
import Warehouse from "./modules/erp/pages/Warehouse";
import BOM from "./modules/erp/pages/BOM";
import EmployeeProfile from "./modules/erp/pages/EmployeeProfile";
import Benefits from "./modules/erp/pages/Benefits";
import SalaryStructure from "./modules/erp/pages/SalaryStructure";
import KPIs from "./modules/erp/pages/KPIs";
import ConfigJournal from "./modules/erp/pages/ConfigJournal";
import ConfigFinancialDimensions from "./modules/erp/pages/ConfigFinancialDimensions";
import AsserCategories from "./modules/erp/pages/AsserCategories";
import InspFranchiseDashboard from "./pages/dashboard/InspFranchiseDashboard";
import MachineAttendanceRecord from "./pages/attendance/MachineAttendanceRecord";
import FeeSetupForms from "./pages/fee_setup_forms/FeeSetupForms";
import FineSetup from "./pages/fine_setup/FineSetup";
import VendorProfile from "./modules/erp/pages/VendorProfile";
import CustomerProfile from "./modules/erp/pages/CustomerProfile";
import AttendanceReport from "./pages/attendance/AttendanceReport";
import NoticeBoardSetup from "./pages/notices/NoticeBoardSetup";
import AttendanceSetupForm from "./pages/attendance/AttendanceSetupForm";
import AssignSchools from "./pages/qa_management/AssignSchools";
//import CreateSchedule from "./pages/qa_management/CreateSchedule";
import QAVisitManagement from "./pages/qa_management/QAVisitManagement";
import VisitsReports from "./pages/qa_management/VisitsReports";
import VisitDetails from "./pages/qa_management/VisitDetails";
import EmployeeProfiles from "./pages/hrms/Employee/EmployeeProfile";
import EmployeeList from "./pages/hrms/Employee/EmployeeList";
import HRMSConfiguration from "./pages/hrms/Employee/HRMSConfiguration";
import PublishPosition from "./pages/hrms/Onboarding/PublishPosition";
import NewApplicantForm from "./pages/hrms/Onboarding/NewApplicantForm";
import InterviewSchedule from "./pages/hrms/Onboarding/InterviewSchedule";
import ApplicantList from "./pages/hrms/Onboarding/ApplicantList";
import StudentFeeLedger from "./pages/billing/StudentFeeLedger";
import FeeReceiveReport from "./pages/billing/FeeReceiveReport";
import BulkFeeVoucher from "./pages/billing/BulkFeeVoucher";
import DayWiseFeeCollection from "./pages/billing/DayWiseFeeCollection";
// Define RoleBasedDashboard component
function RoleBasedDashboard() {
  const roleId = localStorage.getItem("roleId");
  if (roleId === "19") {
    return <AccountsDashboard />;
  }
  return <InspSchoolManagementDashboard />;
}

function AppRoutes({ notificationReceived }) {
  const navigate = useNavigate();
  const username = localStorage.getItem("username");
  const roleId = localStorage.getItem("roleId");

  const [loading, setLoading] = useState(true);

  // const checkTokenValidity = () => {
  //   const token = localStorage.getItem("token");
  //   const expirationTime = localStorage.getItem("tokenExpiration");

  //   if (token && expirationTime) {
  //     const now = new Date();
  //     const expirationDate = new Date(expirationTime);

  //     if (now > expirationDate) {
  //       localStorage.clear();
  //       return false;
  //     }
  //     return true;
  //   }
  //   return false;
  // };

  // const refreshToken = async () => {
  //   const userName = localStorage.getItem("username");
  //   const refreshToken = localStorage.getItem("token");

  //   if (!refreshToken) {
  //     localStorage.clear();
  //     navigate("/login");
  //     return;
  //   }

  //   try {
  //     const response = await post("Auth/RefreshToken", {
  //       userName,
  //       refreshToken,
  //     });

  //     localStorage.setItem("token", response.tokenString);
  //     localStorage.setItem("tokenExpiration", response.expirationTime);
  //   } catch (error) {
  //     localStorage.clear();
  //     navigate("/login");
  //   }
  // };

  // const publicRoutes = ["/register"];

  // useEffect(() => {
  //   const isValidToken = checkTokenValidity();

  //   const currentPath = window.location.pathname;
  //   if (!isValidToken && !publicRoutes.includes(currentPath)) {
  //     navigate("/login");
  //   }
  // }, [navigate]);

  // const [isLoggedIn, setIsLoggedIn] = useState(
  //   !!localStorage.getItem("loggedIn")
  // );

  // useEffect(() => {
  //   const loggedInStatus = localStorage.getItem("loggedIn");
  //   setIsLoggedIn(!!loggedInStatus);
  // }, []);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const expirationTime = localStorage.getItem("tokenExpiration");
  //     if (expirationTime) {
  //       const expirationDate = new Date(expirationTime);
  //       const now = new Date();

  //       if (expirationDate - now < 60000) {
  //         refreshToken();
  //       }
  //     }
  //   }, 30000);

  //   return () => clearInterval(interval);
  // }, []);

  // useEffect(() => {
  //   if (!localStorage.getItem("loggedIn")) return;

  //   let inactivityTimer;

  //   const resetInactivityTimer = () => {
  //     clearTimeout(inactivityTimer);
  //     inactivityTimer = setTimeout(() => {
  //       localStorage.clear();
  //       window.location.reload();
  //     }, 15 * 60 * 1000);
  //   };

  //   const events = ["mousemove", "keypress", "click", "scroll"];

  //   events.forEach((event) =>
  //     window.addEventListener(event, resetInactivityTimer)
  //   );

  //   resetInactivityTimer();

  //   return () => {
  //     clearTimeout(inactivityTimer);
  //     events.forEach((event) =>
  //       window.removeEventListener(event, resetInactivityTimer)
  //     );
  //   };
  // }, [navigate]);

  const checkTokenValidity = () => {
    const token = localStorage.getItem("token");
    const expirationTime = localStorage.getItem("tokenExpiration");

    if (token && expirationTime) {
      const now = new Date();
      const expirationDate = new Date(expirationTime);

      if (now > expirationDate) {
        localStorage.clear();
        return false;
      }
      return true;
    }
    return false;
  };

  const refreshToken = async () => {
    const userName = localStorage.getItem("username");
    const refreshToken = localStorage.getItem("token");

    if (!refreshToken) {
      localStorage.clear();
      navigate("/login");
      return;
    }

    try {
      const response = await post("Auth/RefreshToken", {
        userName,
        refreshToken,
      });

      localStorage.setItem("token", response.tokenString);
      localStorage.setItem("tokenExpiration", response.expirationTime);
    } catch (error) {
      localStorage.clear();
      navigate("/login");
    }
  };

  const publicRoutes = ["/register"];

  useEffect(() => {
    const isValidToken = checkTokenValidity();

    const currentPath = window.location.pathname;
    if (!isValidToken && !publicRoutes.includes(currentPath)) {
      navigate("/login");
    }
  }, [navigate]);

  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("loggedIn"),
  );

  useEffect(() => {
    const loggedInStatus = localStorage.getItem("loggedIn");
    setIsLoggedIn(!!loggedInStatus);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const expirationTime = localStorage.getItem("tokenExpiration");
      if (expirationTime) {
        const expirationDate = new Date(expirationTime);
        const now = new Date();

        if (expirationDate - now < 60000) {
          refreshToken();
        }
      }
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("loggedIn")) return;

    let inactivityTimer;
    const channel = new BroadcastChannel("inactivity-channel");

    const resetInactivityTimer = (isUserActivity = false) => {
      // console.log(
      //   "Resetting inactivity timer, isUserActivity:",
      //   isUserActivity
      // ); // Debugging
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(
        () => {
          // console.log("Inactivity timeout triggered, logging out"); // Debugging
          localStorage.clear();
          navigate("/login");
          window.location.reload();
        },
        15 * 60 * 1000,
      );
      // Only broadcast activity if triggered by user action
      if (isUserActivity) {
        // console.log("Broadcasting activity to other tabs"); // Debugging
        channel.postMessage({ type: "activity" });
      }
    };

    // Listen for activity messages from other tabs
    channel.onmessage = (event) => {
      if (event.data.type === "activity") {
        // console.log("Activity detected from another tab"); // Debugging
        clearTimeout(inactivityTimer);
        resetInactivityTimer(false); // Reset without broadcasting
      }
    };

    const events = ["mousemove", "keypress", "click", "scroll"];
    const handleActivity = () => {
      // console.log("User activity detected"); // Debugging
      resetInactivityTimer(true); // Pass true to indicate user activity
    };

    events.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    resetInactivityTimer(false); // Initial reset without broadcasting

    return () => {
      // console.log("Cleaning up inactivity timer and listeners"); // Debugging
      clearTimeout(inactivityTimer);
      events.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
      channel.close();
    };
  }, [navigate]);

  const [allowedRoutes, setAllowedRoutes] = useState([]);

  useEffect(() => {
    const fetchSidebarMenu = async () => {
      const token = localStorage.getItem("token");
      try {
        const formData = { id: roleId };

        const response = await post(
          `UserAuthentication/GetRolePermissionByRoleId`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const extractedRoutes = response?.sidebar.flatMap((category) =>
          category.subCategories.flatMap((subCategory) =>
            subCategory.forms.map((form) => `/${form.formPath}`),
          ),
        );
        setAllowedRoutes(extractedRoutes);
      } catch (error) {
        console.error("Error fetching sidebar menu:", error);
      } finally {
        setLoading(false);
      }
    };

    if (!roleId || roleId === "null") {
      console.log("Invalid roleId");
      setLoading(false);
    } else {
      fetchSidebarMenu();
    }
  }, [roleId]);

  if (loading) {
    return <FullScreenLoader />;
  }

  return (
    <Routes>
      <Route
        path="/student-first-registration"
        element={<StudentFirstRegistration />}
      />
      <Route path="/admission-voucher" element={<AdmissionVoucher />} />
      <Route path="/monthly-fee-voucher" element={<MonthlyFeeVoucher />} />
      <Route path="/registration-challan" element={<RegistrationChallan />} />


      {!isLoggedIn && (
        <>
          <Route exact path="/" element={<Navigate to="/login" />} />
          <Route
            path="/login"
            element={<Login setIsLoggedIn={setIsLoggedIn} />}
          />
          <Route path="/register" element={<GuardianRegistration />} />
        </>
      )}

      <Route element={<DashboardLayout />}>
        {/* Accounts & Finance */}
        {/* <Route
          path="/erp/accounts/journal-transactions"
          element={<JournalTransactions />}
        />
        <Route path="/erp/accounts/vendors" element={<Vendors />} />
        <Route path="/erp/accounts/customers" element={<Customers />} />
        <Route path="/erp/accounts/vendor-bills" element={<VendorBills />} />
        <Route path="/erp/accounts/invoices" element={<CustomerInvoices />} />
        <Route
          path="/erp/accounts/vendor-payments"
          element={<VendorPayments />}
        />
        <Route
          path="/erp/accounts/customer-receipts"
          element={<CustomerReceipts />}
        />
        <Route path="/erp/accounts/credit-notes" element={<CreditNotes />} />
        <Route path="/erp/accounts/debit-notes" element={<DebitNotes />} />
        <Route
          path="/erp/accounts/bank-reconciliation"
          element={<BankReconciliation />}
        />

        {/* Fixed Assets */}
        <Route path="/erp/assets/assets" element={<FixedAssets />} />
        <Route
          path="/erp/assets/depreciation-schedule"
          element={<DepreciationSchedule />}
        />
        <Route path="/erp/assets/asset-disposal" element={<AssetDisposal />} />{" "}
        <Route path="/employee" element={<EmployeeProfiles />} />
        <Route path="/employee-list" element={<EmployeeList />} />
        <Route path="/hrms-config" element={<HRMSConfiguration />} />
        <Route
          path="/onboarding/publish-position"
          element={<PublishPosition />}
        />
        <Route
          path="/onboarding/new-applicant"
          element={<NewApplicantForm />}
        />
        <Route
          path="/onboarding/interview-schedule"
          element={<InterviewSchedule />}
        />
        <Route path="/onboarding/applicant-list" element={<ApplicantList />} />
        {/* Accounts & Finance */}
        <Route
          path="/erp/accounts/chart-of-accounts"
          element={<ChartOfAccounts />}
        />
        <Route
          path="/erp/accounts/journal-transactions"
          element={<JournalTransactions />}
        />
        <Route path="/erp/accounts/vendors" element={<Vendors />} />
        <Route path="/erp/accounts/vendors/:id" element={<VendorProfile />} />
        <Route path="/erp/accounts/customers" element={<Customers />} />
        <Route
          path="/erp/accounts/customers/:id"
          element={<CustomerProfile />}
        />
        <Route path="/erp/accounts/vendor-bills" element={<VendorBills />} />
        <Route path="/erp/accounts/invoices" element={<CustomerInvoices />} />
        <Route
          path="/erp/accounts/vendor-payments"
          element={<VendorPayments />}
        />
        <Route
          path="/erp/accounts/customer-receipts"
          element={<CustomerReceipts />}
        />
        <Route path="/erp/accounts/credit-notes" element={<CreditNotes />} />
        <Route path="/erp/accounts/debit-notes" element={<DebitNotes />} />
        <Route
          path="/erp/accounts/bank-reconciliation"
          element={<BankReconciliation />}
        />
        {/* Fixed Assets */}
        <Route path="/erp/assets/assets" element={<FixedAssets />} />
        <Route
          path="/erp/assets/asset-categories"
          element={<AsserCategories />}
        />
        <Route
          path="/erp/assets/depreciation-schedule"
          element={<DepreciationSchedule />}
        />
        <Route path="/erp/assets/asset-disposal" element={<AssetDisposal />} />
        {/* Inventory */}
        <Route path="/erp/inventory/products" element={<Products />} />
        <Route path="/erp/inventory/transfer" element={<Transfer />} />
        <Route path="/erp/inventory/issuance" element={<Issuance />} />
        <Route path="/erp/inventory/receipt" element={<Receipt />} />
        <Route path="/erp/inventory/warehouse" element={<Warehouse />} />
        <Route path="/erp/inventory/bom" element={<BOM />} />
        <Route path="/helpdesk-ticketing" element={<TicketsForm />} />
        <Route
          path="/helpdesk-auto-assignment"
          element={<AutoAssignmentSetup />}
        />
        {/* HRMS */}
        {/* 
      <Route
          path="/erp/hrm/employees-profile"
          element={<Employees />} /> */}
        <Route
          path="/erp/hrm/employees-profile/:id"
          element={<EmployeeProfile />}
        />
        <Route path="/erp/hrms/benefits" element={<Benefits />} />
        <Route
          path="/erp/hrms/salary-structure"
          element={<SalaryStructure />}
        />
        <Route path="/erp/hrms/kpis" element={<KPIs />} />
        {/* Configuration */}
        <Route path="/erp/config/journal" element={<ConfigJournal />} />
        <Route
          path="/erp/config/financial-dimensions"
          element={<ConfigFinancialDimensions />}
        />
        {/* Default redirect to chart of accounts */}
        <Route path="/erp" element={<ChartOfAccounts />} />
        {/* Inventory */}
        <Route path="/erp/inventory/products" element={<Products />} />
        <Route path="/erp/inventory/transfer" element={<Transfer />} />
        <Route path="/erp/inventory/issuance" element={<Issuance />} />
        <Route path="/erp/inventory/receipt" element={<Receipt />} />
        <Route path="/erp/inventory/warehouse" element={<Warehouse />} />
        <Route path="/erp/inventory/bom" element={<BOM />} />
        {/* HRMS */}
        <Route
          path="/erp/hrms/employee-profile"
          element={<EmployeeProfile />}
        />
        <Route path="/erp/hrms/benefits" element={<Benefits />} />
        <Route
          path="/erp/hrms/salary-structure"
          element={<SalaryStructure />}
        />
        <Route path="/erp/hrms/kpis" element={<KPIs />} />
        {/* Configuration */}
        <Route path="/erp/config/journal" element={<ConfigJournal />} />
        <Route
          path="/erp/config/financial-dimensions"
          element={<ConfigFinancialDimensions />}
        />
        {/* Default redirect to chart of accounts */}
        <Route path="/erp" element={<ChartOfAccounts />} />
        <Route path="/dashboard" element={<RoleBasedDashboard />} />
        <Route path="/billing-report" element={<BillingReportPage />} />
        <Route path="/bookrequest" element={<BookRequest />} />
        <Route path="/libraryrequest" element={<LibrarianRequest />} />
        <Route path="/cart/:id" element={<ShoppingCart />} />
        <Route path="/salesform" element={<SalesForm />} />
        <Route path="/productlist" element={<ProductList />} />
        <Route path="/uniform" element={<UniformPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/delivery" element={<DeliveryPage />} />
        <Route path="/bookrequest" element={<BookRequest />} />
        <Route path="/libraryrequest" element={<LibrarianRequest />} />
        <Route path="/cart" element={<ShoppingCart />} />
        <Route path="/facility" element={<FacilityForm />} />
        <Route path="/marketing" element={<MarketingCampaign />} />
        <Route path="/asc" element={<Timetables />} />
        <Route path="/ptm_admin" element={<PtmSchedulerAdmin />} />
        <Route path="/ptm_parent" element={<PtmBookingParent />} />
        <Route path="/ptm_teacher" element={<PtmScheduleTeacher />} />
        <Route path="/franchise" element={<FranchiseOnboardingForm />} />
        <Route path="/franchise-list" element={<FranchiseList />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route exact path="/" element={<Navigate to="/dashboard" />} />
        <Route
          path="/parent-student-dashboard"
          element={<ParentStudentDashboard />}
        />
        <Route
          path="/inquiry-to-enrollment-insights"
          element={<InquiryToEnrollmentInsights />}
        />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/application-status" element={<ApplicationStatus />} />
        <Route path="/alert-manager" element={<AlertManager />} />
        <Route path="/email-delivery-status" element={<EmailStatusReport />} />
        <Route
          path="/attachment-template"
          element={<NotificationAttachmentTemplate />}
        />
        {/* <Route path="/create-schedule" element={<CreateSchedule />} /> */}
        <Route path="/qa-visit-management" element={<QAVisitManagement />} />
        <Route path="/visits-reports" element={<VisitsReports />} />
        <Route path="/visit-details" element={<VisitDetails />} />
        <Route path="/check-list-form" element={<QA_CheckListForm />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/registration-form" element={<RegistrationForm />} />
        <Route path="/medical-form" element={<MedicalForm />} />
        <Route path="/student-documents" element={<StudentDocuments />} />
        <Route path="/student-assessment" element={<StudentAssessments />} />
        <Route
          path="/student-assessment-fee"
          element={<StudentAssessmentFee />}
        />
        <Route path="/student-interview" element={<StudentInterview />} />
        <Route path="/student-acceptance" element={<StudentAcceptance />} />
        <Route path="/dropdown-names-setup" element={<DropdownNamesSetup />} />
        <Route
          path="/dropdown-values-setup"
          element={<DropdownValuesSetup />}
        />
        <Route path="/filtering" element={<ColumnFilterTable />} />
        <Route path="/students-list" element={<StudentListings />} />
        <Route path="/define-meeting-slots" element={<DefineMeetingSlots />} />
        <Route path="/enrolled-activities" element={<EnrolledActivities />} />
        <Route path="/alert-manager" element={<AlertManager />} />
        <Route path="/helpdesk-ticketing" element={<TicketsForm />} />
        <Route
          path="/helpdesk-auto-assignment"
          element={<AutoAssignmentSetup />}
        />
        <Route path="/user-report" element={<UserReport />} />
                <Route path="/student-fee-ledger"element={<StudentFeeLedger/>} />
                <Route path="/fee-receive-report"element={<FeeReceiveReport/>}/>
                <Route path="/bulk-fee-voucher"element={<BulkFeeVoucher/>}/>
                <Route path="/day-wise-fee-collection"element={<DayWiseFeeCollection/>}/>

        <Route element={<ProtectedRoute allowedRoutes={allowedRoutes} />}>
          <Route path="/login" element={<Navigate to="/" />} />

          <Route path="/organizations" element={<OrganizationList />} />

          <Route path="/organization-form" element={<OrganizationForm />} />

          <Route path="/organization-levels" element={<OrganizationLevel />} />
          <Route
            path="/organization-level-details"
            element={<OrganizationLevelDetail />}
          />

          <Route path="/centers" element={<CenterList />} />
          <Route path="/center-form/:centerId?" element={<CenterForm />} />

          <Route path="/all-registrations" element={<RegistrationsList />} />

          <Route path="/sessions" element={<SessionSetup />} />
          <Route path="/assign-session" element={<AssignSessionToCenter />} />

          <Route path="/classes" element={<ClassSetup />} />

          <Route path="/class-form/:classId?" element={<ClassForm />} />
          <Route path="/assign-class" element={<AssignClassForm />} />

          <Route path="/section-heads" element={<AssignClassToSectionHead />} />

          <Route path="/class-section" element={<ClassSection />} />

          <Route path="/subjects" element={<SubjectForm />} />
          <Route path="/assign-subjects" element={<AssignSubjectForm />} />

          <Route path="/assign-teacher" element={<AssignTeacher />} />

          <Route path="/students" element={<StudentList />} />

          <Route path="/student-form" element={<StudentForm />} />
          <Route path="/resource-allocation" element={<ResourceAllocation />} />
          <Route path="/fee-setup" element={<FeeSetupForms />} />

          <Route path="/fee-type" element={<FeeType />} />
          <Route path="/fee-cycle" element={<FeeCycle />} />
          <Route path="/fee-plan" element={<FeePlan />} />
          <Route path="/assign-fee-plan" element={<AssignFeePlan />} />
          <Route path="/fee-plan-class-wise" element={<FeePlanClassWise />} />
          <Route path="/monthly-billing" element={<MonthlyBilling />} />
          <Route path="/due-date-setup" element={<DueDateSetup />} />

          <Route path="/concession-plan" element={<ConcessionPlan />} />
          <Route
            path="/assign-concession-plan"
            element={<AssignConcessionPlan />}
          />
          <Route
            path="/concession-plan-class-wise"
            element={<ConcessionPlanClassWise />}
          />

          <Route path="/attendance-setup" element={<AttendanceSetupForm />} />
          <Route path="/academic-calendar" element={<AcademicCalendar />} />
          <Route path="/mark-attendance" element={<MarkAttendance />} />
          <Route path="/attendance-report" element={<AttendanceReport />} />

          <Route path="/activity-setup" element={<ActivitySetup />} />

          <Route
            path="/activity-creation"
            element={<ActivityCreationAndFeedbackForm />}
          />
          <Route
            path="/pupil-activity-enrollment"
            element={<PupilActivityEnrollmentForm />}
          />
          <Route path="/activity-attendance" element={<ActivityAttendance />} />
          <Route
            path="/activity-certificate"
            element={<ActivityCertificate />}
          />

          <Route
            path="/contract-creation"
            element={<SchoolVendorContractForm />}
          />

          <Route path="/assessment-type" element={<AssessmentType />} />
          <Route path="/assessment-plan" element={<AssessmentPlan />} />
          <Route
            path="/assign-assessment-plan"
            element={<AssignAssessmentPlan />}
          />
          <Route path="/booked-assessments" element={<BookedAssessments />} />
          <Route
            path="/assessment-plan-class-wise"
            element={<AssessmentPlanClassWise />}
          />

          <Route path="/admissions" element={<AdmissionList />} />
          <Route
            path="/new-admission/:registrationNoFromUrl?"
            element={<AdmissionMultistepForm />}
          />

          <Route path="/user_auth" element={<UserAuthMainSetup />} />
          <Route path="/site-menu-categories" element={<MenuCategories />} />
          <Route
            path="/site-menu-subcategories"
            element={<MenuSubCategories />}
          />
          <Route path="/site-menu-forms" element={<MenuForms />} />
          <Route path="/site-menu-ordering" element={<MenuOrdering />} />

          <Route path="/site-assign-roles" element={<AssignRoles />} />
          <Route path="/site-permissions" element={<Permissions />} />
          <Route path="/site-role-permissions" element={<RolePermissions />} />
          <Route path="/site-users" element={<Users />} />

          <Route path="/file-manager" element={<FileManager />} />
          <Route path="/file-manager-setup" element={<FileManagerSetup />} />
          <Route
            path="/file-manager-permission"
            element={<FileManagerPermission />}
          />
          <Route path="/authors" element={<AuthorSetup />} />
          <Route path="/books" element={<BookSetup />} />
          <Route path="/bank-setup" element={<BankSetup />} />
          <Route path="/libraries" element={<LibrarySetup />} />
          <Route path="/book-loan" element={<BookLoan />} />
          <Route path="/loaned-books" element={<LoanedBooks />} />
          <Route path="/evaluation-type" element={<EvaluationType />} />
          <Route
            path="/student-achievement-rating"
            element={<StudentAchievementRating />}
          />
          <Route
            path="/assign-grading-to-class"
            element={<AssignGradingTo />}
          />
          <Route path="/subject-item-head" element={<SubjectItemHead />} />
          <Route
            path="/subject-class-evaluation-criteria"
            element={<SubjectClassEvaluationCriteria />}
          />
          <Route
            path="/performance-evaluation"
            element={<PerformanceEvaluation />}
          />
          <Route path="/term-setup" element={<TermSetup />} />
          <Route path="/marks-evaluation" element={<MarksEvaluation />} />
          <Route
            path="/evaluation-criteria-weightage"
            element={<EvaluationCriteriaWeightage />}
          />
          <Route path="/student-profile" element={<StudentProfile />} />

          <Route path="/timetable-setup" element={<TimetableSetup />} />
          <Route path="/timetable" element={<Timetable />} />

          <Route
            path="/student-transfer-out"
            element={<StudentTransferOut />}
          />
          <Route path="/student-transfer-in" element={<StudentTransferIn />} />

          <Route path="/student-withdrawal" element={<StudentWithdrawal />} />
          <Route path="/withdrawal-process" element={<WithdrawalProcess />} />

          <Route
            path="/driver-arrival-status"
            element={
              <DriverArrivalStatusList
                notificationReceived={notificationReceived}
              />
            }
          />

          <Route
            path="/mobile-marketing-content"
            element={<MobileMarketingContentSetup />}
          />

          <Route
            path="/student-early-leave-request"
            element={<EarlyLeaveRequest />}
          />

          <Route path="/diary-setup" element={<DiarySetup />} />
          <Route path="/classwork-setup" element={<ClassWorkSetup />} />

          <Route
            path="/student-performance-report"
            element={<StudentPerformanceReport />}
          />
          <Route
            path="/student-information-report"
            element={<StudentInformationReport />}
          />
          <Route
            path="/student-ledger-report"
            element={<StudentLedgerReport />}
          />
          {/* <Route path="/registration-report" element={<RegistrationReport />} /> */}
          <Route
            path="/registration-report"
            element={<RegistrationDynamicReport />}
          />
          <Route
            path="/student-strength-report"
            element={<StudentStrengthReport />}
          />
          <Route
            path="/student-result-card-report"
            element={<StudentResultCardReport />}
          />
          <Route path="/time-slots" element={<TimeSlots />} />
          <Route path="/notification-form" element={<AlertManagerForm />} />
          <Route
            path="/notification-list"
            element={<AlertNotificationList />}
          />
          <Route
            path="/assign-alert-notification"
            element={<AssignNotification />}
          />
          <Route path="/notification-form" element={<NotificationForm />} />
          <Route path="/form-api-action" element={<FormApiAction />} />
          <Route
            path="/parent-questionnaire-form"
            element={<ParentQuestionerForm />}
          />
          <Route
            path="/parent-questionnaire-form-list"
            element={<ParentQuestionerFormList />}
          />
          <Route path="/student-inquiry" element={<StudentInquiry />} />
          <Route path="/registrations" element={<Approval />} />
          <Route path="/inspstudent-profile" element={<InspStudentProfile />} />
          <Route
            path="franchise-dashboard"
            element={<InspFranchiseDashboard />}
          />

          <Route path="/expense-allocation" element={<ExpenseAllocation />} />
          <Route path="/role-setup" element={<RoleSetup />} />

          <Route path="/workflow-setup" element={<WorkflowSetupForms />} />
          <Route path="/notices-setup" element={<NoticeBoardSetup />} />
          <Route
            path="/machine-attendance-record"
            element={<MachineAttendanceRecord />}
          />
          <Route path="/fine-setup" element={<FineSetup />} />
          <Route path="/assign-schools" element={<AssignSchools />} />
          {/* <Route path="/create-schedule" element={<CreateSchedule />} /> */}
          <Route path="/qa-visit-management" element={<QAVisitManagement />} />
          <Route path="/visits-reports" element={<VisitsReports />} />
          <Route path="/visit-details" element={<VisitDetails />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default AppRoutes;
